<div class="d-flex flex-column align-items-start gap-3">
    @if (hasExistingVisions) {
        <button class="btn btn-primary align-self-center"
                [adaptBlockingClick]="gotoVisionPage">Navigate to vision page</button>
    } @else {
        <span>Use the button below to begin capturing the team's vision and navigate to the vision page.</span>
        <button class="btn btn-primary align-self-center"
                [adaptBlockingClick]="captureVision">Capture vision</button>
    }
</div>
